<script setup lang="ts">
import {ref, watch} from "vue";
import {trackEvent} from "@/services/event.service";

defineEmits(['update:value'])
const model = defineModel()

const props = defineProps({
  title: String,
  event_id: String,
  event_label: String,
  placeholder: {
    type: String,
    default: "Select filter"
  },
  remote: {
    type: Function
  },
  loading: {
    type: Boolean
  },
  options: {
    type: Array,
    default: () => []
  },
  enabled: {
    type: Boolean,
    default: true
  }
})

const selected = ref(model.value);
const searchQuery = ref(""); // Store user input
const filteredOptions = ref(props.options); // Maintain filtered options


const update = () => {
  model.value = selected.value;

  // Get the selected labels based on the selected values (IDs)
  const selectedLabels = props.options
      .filter(option => selected.value.includes(option.value || option.id))
      .map(option => option.label || option.name);

  trackEvent(`cosmosy.ga.filters.${props.event_id}`, {
    event_label: props.event_label || props.title,
    selected_ids: selected.value.join(','),
    label_added: selectedLabels.join(', '),
    selected_count: selected.value.length
  });

};


watch(model, (value) => {
  selected.value = value;
});

watch(() => props.options, (newOptions) => {
  console.log("Updated options:", newOptions);
  filteredOptions.value = newOptions;
}, { deep: true });


const filterMethod = (query) => {
  console.log("Filtering with query:", query);
  searchQuery.value = query;

  if (!query) {
    filteredOptions.value = props.options;
    return;
  }

  if (props.remote) {
    props.remote(query);
  } else {
    filteredOptions.value = props.options.filter(option =>
        (option.label || option.name || "").toLowerCase().includes(query.toLowerCase())
    );
  }
};

</script>

<template>
  <div class="font-bold responsive-title-6"
       :class="!props.enabled ? 'color-gray' : ''">
    {{ props.title }}
  </div>

  <el-select
      v-model="selected"
      :placeholder="props.placeholder"
      filterable
      :loading="props.loading"
      :disabled="!props.enabled"
      multiple
      clearable
      collapse-tags
      collapse-tags-tooltip
      remote
      :filter-method="filterMethod"
      :reserve-keyword="false"
      @change="update"
      size="large">

    <el-option
        v-for="option in filteredOptions"
        :key="option?.value || option?.id"
        :label="option?.label || option?.name"
        :value="option?.value || option?.id">
    </el-option>

  </el-select>
</template>